/* eslint-disable lines-between-class-members */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { later } from '@ember/runloop';
import { tracked } from '@glimmer/tracking';
import { showGroupPreviewDialog } from 'mewe/utils/dialogs-common';

export default class MwSmartSearchGroup extends Component {
  @service router;
  @service dynamicDialogs;

  @tracked showJoinProgress = false;

  @action
  click() {
    if (this.args.group.isMember) {
      this.router.transitionTo('app.group', this.args.group.id);
      this.args.closeSmartSearch();
    } else {
      showGroupPreviewDialog(this.dynamicDialogs, this.args.group, {
        context: 'search',
      });
    }
  }

  @action
  joinGroup(e) {
    e?.stopPropagation();

    this.showJoinProgress = true;

    // use logic from group-preview-dialog for joining
    showGroupPreviewDialog(this.dynamicDialogs, this.args.group, {
      isJoinIntentFlow: true,
      context: 'search'
    });

    later(() => {
      this.showJoinProgress = false;
    }, 1000);
  }
}
